<!--
 * @Description: 教材存放位置 详情
 * @Author: ZSC
 * @Date: 2023-04-19 13:30:05.638
 * @LastEditors: PF
 * @LastEditTime: 2025-07-16 15:44:45
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="4" border class="descript-box">
        <el-descriptions-item label="学生学号" label-align="right" align="left" width="150px" span="2">{{ ruleForm.xsxh }}</el-descriptions-item>
        <el-descriptions-item label="学生姓名" label-align="right" align="left" width="150px" span="2">{{ ruleForm.xsxm }}</el-descriptions-item>
        <el-descriptions-item label="证书类型" label-align="right" align="left" span="2"><span v-if="ruleForm.zslx">{{ ruleForm.zslx.name }}</span></el-descriptions-item>
        <el-descriptions-item label="证书编号" label-align="right" align="left" span="2">{{ ruleForm.zsbh }}</el-descriptions-item>
        <el-descriptions-item label="证书等级码" label-align="right" align="left" span="2">{{ ruleForm.zsdjm }}</el-descriptions-item>
        <el-descriptions-item label="发放人" label-align="right" align="left" span="2">{{ ruleForm.ffrxm }}</el-descriptions-item>
        <el-descriptions-item label="发证机构" label-align="right" align="left" span="2">{{ruleForm.fzjg}}</el-descriptions-item>
        <el-descriptions-item label="发放人电话" label-align="right" align="left" span="2">{{ruleForm.ffrdh}}</el-descriptions-item>
        <el-descriptions-item label="发放时间" label-align="right" align="left" span="2">{{ ruleForm.ffsj }}</el-descriptions-item>
        <el-descriptions-item label="是否支持电子证书" label-align="right" align="left" span="2">
          <span v-if="ruleForm.sfzcdzzs == '是'">支持</span>
          <span v-if="ruleForm.sfzcdzzs == '否'">不支持</span>
        </el-descriptions-item>
        <el-descriptions-item label="是否邮寄" label-align="right" align="left" span="2">
          <span v-if="ruleForm.sfyj == true">邮寄</span>
          <span v-if="ruleForm.sfyj == false">不邮寄</span>
        </el-descriptions-item>
        <el-descriptions-item label="收件人" label-align="right" align="left" span="2">{{ ruleForm.sjr }}</el-descriptions-item>
        <el-descriptions-item label="收件人电话" label-align="right" align="left" span="2">{{ ruleForm.sjrdh }}</el-descriptions-item>
        <el-descriptions-item label="邮寄人" label-align="right" align="left" span="2">{{ ruleForm.yjrxm }}</el-descriptions-item>
        <el-descriptions-item label="邮寄时间" label-align="right" align="left" span="2">{{ ruleForm.yjsj }}</el-descriptions-item>
        <el-descriptions-item label="邮寄方式" label-align="right" align="left" span="2">{{ ruleForm.yjfs }}</el-descriptions-item>
        <el-descriptions-item label="邮寄单号" label-align="right" align="left" span="2">{{ ruleForm.yjdh }}</el-descriptions-item>
        <el-descriptions-item label="邮寄邮编" label-align="right" align="left" span="2">{{ ruleForm.yjyb }}</el-descriptions-item>
        <el-descriptions-item label="邮寄地址" label-align="right" align="left" span="4">{{ ruleForm.yjdz }}</el-descriptions-item>
        <el-descriptions-item label="" label-align="right" align="left" span="4"></el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const ruleForm = ref({})
const emits = defineEmits(['update:openDetail'])

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({ url: '/api/v2/jiaowu/xueshengzhengshufafangjilu/' + props.row.id, ruleForm })
    }
  },
  { deep: true, immediate: true }
)
</script>
